import ModelLoader from "../common/ModelLoader";
export default class AirportModel {
    model;
    constructor() {
        const loader = new ModelLoader();
        this.model = loader.load("/models/atc.glb", "atc");
    }
    getModel() {
        return this.model;
    }
}
